import star from "@/features/offers/assets/reviews/star.svg"
import verified from "@/features/offers/assets/reviews/verified.svg"
import type { OfferReview } from "../types"

interface OfferReviewsProps {
  heading: string
  items: OfferReview[]
}

/** "What users say…" heading + review cards (avatar, stars, verified badge). */
export function OfferReviews({ heading, items }: OfferReviewsProps) {
  return (
    <div data-slot="offer-reviews" className="flex flex-col gap-4">
      <h2 className="text-center font-display text-2xl font-medium text-purple-light">{heading}</h2>
      <div className="flex flex-col gap-2">
        {items.map((review) => (
          <div
            key={review.name}
            className="flex flex-col gap-4 rounded-[16px] border border-purple-light/20 p-4"
          >
            <p className="text-base leading-snug text-purple-light/70">{review.text}</p>
            <div className="flex items-center justify-between gap-4">
              <div className="flex min-w-0 flex-1 items-center gap-2">
                <img
                  src={review.avatar}
                  alt=""
                  className="size-10 shrink-0 rounded-full object-cover"
                />
                <div className="flex min-w-0 flex-col">
                  <p className="font-display text-base font-medium text-purple-light">
                    {review.name}
                  </p>
                  <div className="flex items-center gap-1">
                    <div className="flex items-center">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <img key={i} src={star} alt="" className="size-4" />
                      ))}
                    </div>
                    <span className="text-sm font-medium leading-5 text-gold">{review.rating}</span>
                  </div>
                </div>
              </div>
              <div className="flex shrink-0 items-center gap-1 rounded-[14px] bg-green/10 py-1.5 pl-1.5 pr-2">
                <img src={verified} alt="" className="size-4" />
                <span className="text-xs font-semibold text-green">Verified review</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
